import { render, staticRenderFns } from "./AccountLogin.vue?vue&type=template&id=95d1ba36&scoped=true"
import script from "./AccountLogin.vue?vue&type=script&lang=js"
export * from "./AccountLogin.vue?vue&type=script&lang=js"
import style0 from "./AccountLogin.vue?vue&type=style&index=0&id=95d1ba36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d1ba36",
  null
  
)

export default component.exports